import type { ElementoEtiqueta } from '../../api';

/** Lo que comparten el lienzo y los paneles del diseñador. */

/** Al arrastrar y al escribir medidas, se redondea a un cuarto de milímetro. */
export const PASO_MM = 0.25;
export const ajustar = (v: number) => Math.round(v / PASO_MM) * PASO_MM;
export const acotar = (v: number, min: number, max: number) => Math.min(max, Math.max(min, v));

/** Redondea a una cuadrícula: 0 quiere decir sin cuadrícula. */
export const aCuadricula = (v: number, paso: number) => (paso > 0 ? Math.round(v / paso) * paso : v);

export const NOMBRES: Record<ElementoEtiqueta['tipo'], string> = {
  texto: 'Texto',
  barras: 'Código de barras',
  qr: 'Código QR',
  linea: 'Línea',
  rectangulo: 'Rectángulo',
  logo: 'Logo',
};

export const ICONOS: Record<ElementoEtiqueta['tipo'], string> = {
  texto: 'title',
  barras: 'barcode',
  qr: 'qr_code_2',
  linea: 'horizontal_rule',
  rectangulo: 'crop_square',
  logo: 'image',
};

let contador = 0;
export const nuevoId = () => `el-${Date.now().toString(36)}-${(contador++).toString(36)}`;

/** Un elemento recién puesto, con medidas que se vean sin tener que tocarlas. */
export function elementoNuevo(tipo: ElementoEtiqueta['tipo'], ancho: number, alto: number): ElementoEtiqueta {
  const base = { id: nuevoId(), tipo, x: ajustar(ancho * 0.1), y: ajustar(alto * 0.1), giro: 0 };

  switch (tipo) {
    case 'texto':
      return { ...base, ancho: ajustar(ancho * 0.8), alto: 6, contenido: 'Texto', cuerpo: 4, alineacion: 'izquierda' };
    case 'barras':
      return { ...base, ancho: ajustar(ancho * 0.8), alto: 16, contenido: '{{capacho.id}}', mostrarTexto: true };
    case 'qr':
      return { ...base, ancho: 20, alto: 20, contenido: '{{capacho.id}}', correccion: 'M' };
    case 'linea':
      return { ...base, ancho: ajustar(ancho * 0.8), alto: 0.4, grosor: 0.4 };
    case 'rectangulo':
      return { ...base, ancho: ajustar(ancho * 0.8), alto: 20, grosor: 0.4, relleno: false };
    case 'logo':
      return { ...base, ancho: 24, alto: 19 };
  }
}

/** Una copia del elemento con identificador nuevo, corrida para que se vea. */
export const duplicarElemento = (e: ElementoEtiqueta, corrimiento = 3): ElementoEtiqueta => ({
  ...e,
  id: nuevoId(),
  x: e.x + corrimiento,
  y: e.y + corrimiento,
  // La copia sale del grupo: si no, duplicar un grupo lo mete en el mismo y
  // después no hay forma de mover uno sin el otro.
  grupo: null,
});
